<template>
  <div class="referred">
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-btn :style=" get_tab_style(0)" :class="get_tab_style(0)" @click="set_active_tab(0)">مرخصی های من</v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn :style=" get_tab_style(1)" @click="set_active_tab(1)">مرخصی دیگران</v-btn>
        </v-col>
      </v-row>
<v-row v-if="active_tab==0">
  <MyMorakhasiList/>
</v-row>
<v-row v-if="active_tab==1">
  <ReferMorakhasiList/>
</v-row>

    </v-card-text>

  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import { longClickDirective } from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";
import MyMorakhasiList from "./MyMorakhasiList";
import ReferMorakhasiList from "./ReferMorakhasiList";
  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        active_tab:0,
        product_info_dialog:false,
        selected_product_info:{},
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click:false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect,
      MyMorakhasiList,
      ReferMorakhasiList,
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {
      this.get_pre_requests()

    },

    methods: {
      get_tab_style(index){
        if(index==this.active_tab){
          return 'width: 100%;padding: 0px;margin:0px;border-radius: 0px;background-color:blue!important'

        }else{
          return 'width: 100%;padding: 0px;margin:0px;border-radius: 0px;background-color:white!important;color:black!important'

        }
      },
      set_active_tab(index){
        this.active_tab = index;
      },
      get_pre_requests($state) {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          Count: this.page,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProductRequestReferByUserId', send_data, {})
          .then(response => {
            self.request_items = []
            if (response.data.error == 0) {
              response.data.Items.forEach(function (number) {
                if (self.request_items.filter(x => x.ProductId == number.ProductId).length == 0) {
                  if (response.data.Items.filter(x => x.ProductId == number.ProductId).length == 1) {
                    number.related_products = []
                    self.request_items.push(JSON.parse(JSON.stringify(number)))
                  } else {
                    var item = JSON.parse(JSON.stringify(number));
                    item.related_products = response.data.Items.filter(x => x.ProductId == number.ProductId);
                    var final_qty = 0;
                    for (var i = 0; i < response.data.Items.filter(x => x.ProductId == number.ProductId).length; i++) {
                      final_qty += response.data.Items.filter(x => x.ProductId == number.ProductId)[i].Qty;
                    }
                    item.final_qty = final_qty;
                    self.request_items.push(item)

                  }
                }
              })

              console.log("itemsss",self.request_items)
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      open_image(img){
        window.open(img,'_blank')
      },
      goToDetail(item,is_parent){
        if(this.disable_click){
          return;
        }
        console.log("go to detail worked",item)
        if(is_parent==1 && item.related_products!=null && item.related_products.length==0 ){
          this.selected_product_info = item;
          this.product_info_dialog = true;
        }
        if(is_parent==0){
          this.selected_product_info = item;
          this.product_info_dialog = true;

        }

      },
      long_click(item){
        var self= this;
       if(item.selected==null){
         item.selected=true
         console.log("long click worked")

       }else{
         item.selected=null
       }
       this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if(this.request_items.filter(x=>x.selected==true).length>0){
          this.enable_finalize = true;
        }else{
          this.enable_finalize = false;

        }
       this.$forceUpdate()
      },
      card_style(item){
       if(item.selected){
         return "blue";

       }else{
         return "";

       }
      },
      go_to_finalize(){
        var array = this.request_items.filter(x=>x.selected==true);
        console.log(array);
       localStorage.setItem('buy_orders_finalize',JSON.stringify(array));
       this.$router.push({name:'BuyOrdersFinalize'})
      }
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
